import { ApiType, ApiEndpoint } from "/shortcodes";
import CustomFieldsSetCustomFieldUpdateActionGeneric from "@commercetools-local/topics/custom-fields/set-custom-field-update-action-generic.mdx";
import * as React from 'react';
export default {
  ApiType,
  ApiEndpoint,
  CustomFieldsSetCustomFieldUpdateActionGeneric,
  React
};